import { createSlice } from '@reduxjs/toolkit';
import { generateStateSingle } from '../../generators/generateState';
import { fetchData, fetchEditData } from '../../generators/generateThunks';

const SLICE_NAME = 'jobWork';

export const fetchJobWorks = fetchData.generateThunk(SLICE_NAME, SLICE_NAME);

export const fetchJobWork = fetchEditData.generateThunk(SLICE_NAME, SLICE_NAME);

const jobWorkSlice = createSlice({
    name: SLICE_NAME,
    initialState: generateStateSingle(SLICE_NAME),
    extraReducers: {
        ...fetchData.generateExtraReducers(fetchJobWorks, SLICE_NAME),
        ...fetchEditData.generateExtraReducers(fetchJobWork, SLICE_NAME),
    },
});

export const getJobWorks = (state) => state.jobWork;

export default jobWorkSlice.reducer;
